import { useTheme } from "@/theme/ThemeProvider";
import type { IconComponent } from "@/ui/entityVisuals";
import { Pressable, Text } from "react-native";

/**
 * Kompakte Aktion für Kopfzeilen (z. B. SectionCard `headerRight`): Icon + kurzer Text.
 * Ersetzt handgebaute „Neu"-Pressables, damit alle Kopf-Aktionen gleich aussehen.
 */
export function HeaderAction({
  icon: Icon,
  label,
  onPress,
  tone,
}: {
  icon?: IconComponent;
  label: string;
  onPress: () => void;
  tone?: "primary" | "danger";
}) {
  const { theme } = useTheme();
  const color = tone === "danger" ? theme.color.danger : theme.color.primary;
  return (
    <Pressable
      onPress={onPress}
      hitSlop={8}
      accessibilityRole="button"
      accessibilityLabel={label}
      style={({ pressed }) => ({
        flexDirection: "row",
        alignItems: "center",
        gap: theme.space.xs,
        opacity: pressed ? 0.6 : 1,
      })}
    >
      {Icon ? <Icon size={16} color={color} weight="bold" /> : null}
      <Text style={{ fontSize: theme.fontSize.small, fontWeight: "700", color }}>{label}</Text>
    </Pressable>
  );
}
